import './AccountPages.scss'
import React, { useEffect } from 'react'
import BEMHelper from 'react-bem-helper'
import { useConnect } from 'redux-bundler-hook'
import PriceLevel from '@src/components/PriceLevel'
import { googleAnalytics } from '@src/api/googleanalytics/googleAnalytics'
import { REGISTRATION_STEPS } from '@src/components/account/Account'

const bem = new BEMHelper('registration-page')

const priceLevels = [
	{
		id: 'OL8A-67UI',
		title: 'Free',
		monthlyCost: 0,
		description: 'Passar dig som endast kör vid enstaka tillfällen.',
	},
	{
		id: 'PO00-09LK',
		title: 'Sliver',
		monthlyCost: 99,
		description: 'Passar dig som endast kör vid enstaka tillfällen.',
	},
	{
		id: 'AKFA-JI87',
		title: 'Goold',
		monthlyCost: 299,
		description: 'Passar dig som endast kör vid enstaka tillfällen.',
	},
]

function ChooseAccountLevelPage({ setNextStep }) {
	const { doSetChoosenAccountLevel, selectedPriceLevel } = useConnect(
		'doSetChoosenAccountLevel',
		'selectSelectedPriceLevel',
	)

	const onPriceLevelSelected = (priceLevel) => {
		doSetChoosenAccountLevel(priceLevel.id)
		setNextStep(REGISTRATION_STEPS.CONTACT_INFORMATION)
	}

	useEffect(() => {
		googleAnalytics.pushVirtualPageView(
			`/virtual/account/chooseaccountlevelpage`,
			`User is selecting account level`,
		)
	}, [])

	return (
		<div {...bem('')}>
			{priceLevels.map((item, index) => (
				<PriceLevel
					selected={item.id === selectedPriceLevel}
					key={`pricelevel-${index}`}
					priceLevel={item}
					onClick={(priceLevel) => onPriceLevelSelected(priceLevel)}
				/>
			))}
		</div>
	)
}

export default ChooseAccountLevelPage
